import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-pass-limits',
	templateUrl: './icon-pass-limits.component.svg',
})
export class IconPassLimitsComponent {}
